import http from "./httpService";

/**
 * @typedef {import('../types/api.js').SignatureMakercartParams} SignatureMakercartParams
 * @typedef {import('../types/api.js').SignatureMakercart} SignatureMakercart
 * @typedef {import('../types/api.js').SignatureMakercartListData} SignatureMakercartListData
 * @typedef {import('../types/api.js').AddSignatureMakercartRequest} AddSignatureMakercartRequest
 * @typedef {import('../types/api.js').ApiResponseWithError} ApiResponseWithError
 */

class SignatureMakercartService {
  /**
   * Get paginated list of signature makercarts
   * @param {SignatureMakercartParams} param - Query parameters for filtering and pagination
   * @returns {Promise<ApiResponseWithError & { data: SignatureMakercartListData }>} Signature makercart list response
   */
  async getSignatureMakercart(param) {
    const url = http.getUrlWithParams("/signature-cart", param);
    const response = await http.get(url);
    return response.data;
  }

  /**
   * Get a specific signature makercart by ID
   * @param {string} id - Signature makercart ID
   * @returns {Promise<ApiResponseWithError & { data: SignatureMakercart }>} Signature makercart response
   */
  async getSignatureMakercartById(id) {
    const response = await http.get(`/signature-cart/${id}`);
    return response.data;
  }

  /**
   * Add signature makercart to user cart
   * @param {string} signatureId - Signature makercart ID
   * @param {AddSignatureMakercartRequest} data - Signature makercart data
   * @returns {Promise<ApiResponseWithError>} Add signature makercart response
   */
  async addSignatureMakercart(signatureId, data) {
    const response = await http.post(
      `/signature-cart/bundle/${signatureId}`,
      data
    );
    return response.data;
  }

  /**
   * Convert signature makercart to custom cart
   * @param {string} signatureId - Signature makercart ID
   * @returns {Promise<ApiResponseWithError>} Convert signature makercart to custom cart response
   */
  async convertToCustom(signatureId) {
    const response = await http.put(
      `/signature-cart/convert-to-custom/${signatureId}`
    );
    return response.data;
  }
}

export default new SignatureMakercartService();
